import { apiWithPrefix as api } from '../utils/api';

export class NotificationService {
  static async getMyNotifications(filter = 'all') {
    const response = await api.get('/notifications/my', {
      params: { filter }
    });
    return response.data;
  }

  static async markAsRead(id) {
    const response = await api.put(`/notifications/${id}/read`);
    return response.data;
  }

  static async deleteNotification(id) {
    const response = await api.delete(`/notifications/${id}`);
    return response.data;
  }

  static async getPreferences() {
    const response = await api.get('/notifications/preferences');
    return response.data;
  }

  static async updatePreferences(data) {
    const response = await api.put('/notifications/preferences', data);
    return response.data;
  }

  static async sendTestNotification() {
    const response = await api.post('/notifications/test');
    return response.data;
  }
}

export default NotificationService;
